import { createApi } from '@reduxjs/toolkit/query/react';
import { TrajectorySectionType } from 'src/config/api/models/Trajectory';
import apiRoutesV2 from 'src/config/api/routes';
import { appBaseQuery } from '../helpers';

export const printPdfApi = createApi({
  reducerPath: 'printPdfApi',
  baseQuery: appBaseQuery,
  endpoints: (builder) => ({
    getTrajectoryToPrintPDF: builder.query<
      string,
      { trajectoryId: string; pageType: TrajectorySectionType }
    >({
      query: ({ trajectoryId, pageType }) => ({
        url: apiRoutesV2.getTrajectoryToPrint(trajectoryId, pageType),
        method: 'GET',
      }),
      transformResponse: (response: { data: { file: string } }, meta, arg) => {
        if (response.data.file) return response.data.file;
        const url = apiRoutesV2.getTrajectoryToPrint(arg.trajectoryId, arg.pageType);
        return `${url}/download`;
      },
    }),
  }),
});

export const { useGetTrajectoryToPrintPDFQuery } = printPdfApi;
